import { useQuery } from '@tanstack/react-query';

import { dataTrendApi } from '../api';
import { CalendarDataWeeklyTrendWithData } from '@demind-inc/core';
 
interface UseCalendarWeeklyTrendParams {
  userId: string;
  startDate: string;
  endDate: string;
  dataTrendId: string;
  enabled?: boolean;
}

interface UseCalendarWeeklyTrendQueryParams {
  queryKey: ['lifestack.trend.calendar.weekly', UseCalendarWeeklyTrendParams];
}

export const useFetchCalendarWeeklyTrend = ({
  userId,
  startDate,
  endDate,
  dataTrendId,
  enabled = true,
}: UseCalendarWeeklyTrendParams) => {
  const calendarWeeklyTrendQuery = useQuery({
    queryKey: ['lifestack.trend.calendar.weekly', { userId, startDate, endDate, dataTrendId }],
    queryFn: ({ queryKey }: UseCalendarWeeklyTrendQueryParams) => {
      const [, { userId, startDate, endDate, dataTrendId }] = queryKey;
      return dataTrendApi
        .getCalendarWeeklyTrend(userId, startDate, endDate, dataTrendId)
        .then(({ data }) => data as CalendarDataWeeklyTrendWithData);
    },
    refetchOnWindowFocus: false,
    staleTime: 15000, // 15s
    enabled: !!userId && !!dataTrendId && enabled,
  });

  return {
    calendarWeeklyTrend: calendarWeeklyTrendQuery.data,
    ...calendarWeeklyTrendQuery,
  };
}; 